import { render, staticRenderFns } from "./ModalAttachment.vue?vue&type=template&id=dbc1fd48&"
import script from "./ModalAttachment.vue?vue&type=script&lang=js&"
export * from "./ModalAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports